import './App.css';
import { Routes , Route  } from 'react-router-dom';
import Home from './pages/home/home';
import {NavBar} from './components/navBar/navBar';
import {Footer} from './components/footer/footer';
import Privacy from './pages/privacy/privacy';
import ThankYou from './pages/signUpMessage/thankYou';
import Invalid from './pages/signUpMessage/invalid';
import AppStoreLink from './pages/appStoreLink/appStoreLink';
import Redirect from "./pages/redirect/redirect";

function App() {
  return (
    <div className="App">
      {window.location.pathname !== "/privacy" ? <div className='Background'/> : null}
      <NavBar route={window.location.pathname}/>
      <Routes>
        <Route exact path="/download" element={<AppStoreLink />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/thankYou" element={<ThankYou />} />
        <Route exact path="/invalid" element={<Invalid />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
